define(['backbone'], (Backbone) => Backbone.Model.extend({
    defaults: {
        id: null,
        code: '',
        name: '',
        symbol: '',
        full_name: ''
    }
}));
